import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import { ticketGroupTableSelectAllSelector } from '../../store/selectors';
import { ButtonBase } from '@material-ui/core';
import { ticketGroupTableActions } from '../../store/actions';
import styled from 'styled-components/macro';
import { ticketGroupTableSelectedIdCountSelector } from '../../store/selectors/ticket-group-table.selector';
import { canSelectTicketSelector } from 'store/selectors/workdesk-filter.selector';

interface SelectAllCheckboxProps {}

/* ALL SOME NONE */

const selectAllValueToIconClassMap = {
  ALL: CheckBoxIcon,
  SOME: IndeterminateCheckBoxIcon,
  NONE: CheckBoxOutlineBlankIcon,
};

const selectAllValueToAfterClickValueMap = {
  ALL: 'NONE',
  SOME: 'NONE',
  NONE: 'ALL',
};

const SelectAllCheckbox: React.FC<SelectAllCheckboxProps> = () => {
  const selectedAll = useSelector(ticketGroupTableSelectAllSelector);
  const count = useSelector(ticketGroupTableSelectedIdCountSelector);
  const dispatch = useDispatch();
  const SelectAllIconClass = useMemo(
    () => selectAllValueToIconClassMap[selectedAll],
    [selectedAll],
  );
  const handleOnClick = () => {
    const nextValue = selectAllValueToAfterClickValueMap[selectedAll];
    dispatch(ticketGroupTableActions.setSelectedAll(nextValue));
  };
  const canSelectTicket = useSelector(canSelectTicketSelector);
  useEffect(() => {
    console.debug(`selectedAll: `, selectedAll);
  }, [selectedAll]);
  return (
    <SRoot>
      <SButtonBase
        disabled={!canSelectTicket}
        onClick={() => handleOnClick()}
      >
        <SelectAllIconClass />
      </SButtonBase>
      <SCount>{count > 0 ? `(${count})` : null}</SCount>
    </SRoot>
  );
};

export default SelectAllCheckbox;
const SButtonBase = styled(ButtonBase)`
  &.MuiButtonBase-root {
    margin-right: 1px;
  }

  &.MuiButtonBase-root.Mui-disabled > svg > path {
    fill: ${(props) => props.theme.palette.text.disabled};
  }
`;
const SRoot = styled.div`
  display: flex;
  align-items: center;
`;
const SCount = styled.div`
  color: ${(props) => props.theme.palette.text.secondary};
  font-size: ${(props) => props.theme.typography.fontSize.extraSmall};
  margin-right: 5px;
`;
